// The header's three mega menus. Data only, so a test can check each link against `sectionOf`.
import { EDGE_LOCATION_COUNT } from '@/lib/check-locations'

export type MenuItem = { label: string; href: string; description?: string; badge?: string }
export type MenuColumn = { title: string; items: MenuItem[] }
export type Menu = { label: string; columns: MenuColumn[] }

export const monitoringMenu: Menu = {
  label: 'Monitoring',
  columns: [
    {
      title: 'Monitor Types',
      items: [
        { label: 'Uptime Monitoring', href: '/features/uptime-monitoring', description: 'HTTP, HTTPS, TCP, Ping' },
        { label: 'Cron & Heartbeat', href: '/features/heartbeat-monitoring', description: 'Passive job monitoring' },
        { label: 'SSL Certificates', href: '/features/ssl-monitoring', description: 'Expiry alerts & chain checks' },
        { label: 'DNS Monitoring', href: '/features/dns-monitoring', description: 'A, CNAME, MX, TXT records' },
        { label: 'Status Pages', href: '/features/status-pages', description: 'Public & branded pages' },
        { label: 'Keyword Monitoring', href: '/features/keyword-monitoring', description: 'Content presence checks' },
        { label: 'Browser Monitoring', href: '/features/browser-monitoring', description: 'Playwright flows & visual checks' },
      ],
    },
    {
      title: 'Integrations',
      items: [
        { label: 'Alert Confirmation', href: '/#how-it-works', description: '2-5 consecutive checks', badge: 'Core' },
        { label: 'Email', href: '/integrations/email' },
        { label: 'Slack', href: '/integrations/slack' },
        { label: 'Discord', href: '/integrations/discord' },
        { label: 'Telegram', href: '/integrations/telegram' },
        { label: 'n8n', href: '/integrations/n8n', description: 'Community node' },
        { label: 'REST API', href: '/docs', description: 'Interactive API docs' },
        { label: 'MCP Server', href: '/guides/mcp', description: 'Connect Claude to Uptrack' },
        { label: 'All Guides', href: '/guides', description: 'Tutorials & setup guides' },
      ],
    },
  ],
}

export const toolsMenu: Menu = {
  label: 'Tools',
  columns: [
    {
      title: 'Domain & DNS',
      items: [
        { label: 'WHOIS Lookup', href: '/tools/whois-lookup', description: 'Registrar, dates, name servers' },
        { label: 'Domain Expiry Checker', href: '/tools/domain-expiry-checker', description: 'Expiration date and days left' },
        { label: 'Domain Age Checker', href: '/tools/domain-age-checker', description: 'Age from registration date' },
        { label: 'DNS Lookup', href: '/tools/dns-lookup', description: 'A, MX, TXT, NS and more' },
        { label: 'MX Lookup', href: '/tools/mx-lookup', description: 'Mail servers and priority' },
        { label: 'TXT Record Lookup', href: '/tools/txt-record-lookup', description: 'SPF, DKIM and DMARC' },
        { label: 'DNS Propagation Checker', href: '/tools/dns-propagation-checker', description: 'Compare three public resolvers' },
        { label: 'SSL Checker', href: '/tools/ssl-checker', description: 'Certificate expiry and chain' },
      ],
    },
    {
      title: 'Website & Uptime',
      items: [
        { label: 'Free Browser Check', href: '/tools/browser-check', description: 'Screenshot + Core Web Vitals', badge: 'New' },
        { label: 'Is Website Down?', href: '/tools/is-website-down', description: `Check from ${EDGE_LOCATION_COUNT} locations` },
        { label: 'Uptime Calculator', href: '/tools/uptime-calculator', description: 'Allowed downtime per period' },
        { label: 'SLA Calculator', href: '/tools/sla-calculator', description: 'Downtime and error budget' },
        { label: 'Downtime Cost Calculator', href: '/tools/downtime-cost-calculator', description: 'What an outage costs you' },
        { label: 'All Free Tools', href: '/tools', description: 'Every tool in one list' },
      ],
    },
  ],
}

export const compareMenu: Menu = {
  label: 'Compare',
  columns: [
    {
      title: 'Popular',
      items: [
        { label: 'vs UptimeRobot', href: '/compare/uptimerobot' },
        { label: 'vs Better Stack', href: '/compare/betterstack' },
        { label: 'vs Pingdom', href: '/compare/pingdom' },
        { label: 'vs Datadog', href: '/compare/datadog' },
        { label: 'vs HetrixTools', href: '/compare/hetrixtools' },
      ],
    },
    {
      title: 'More',
      items: [
        { label: 'vs StatusCake', href: '/compare/statuscake' },
        { label: 'vs Checkly', href: '/compare/checkly' },
        { label: 'vs Hyperping', href: '/compare/hyperping' },
        { label: 'vs Oh Dear', href: '/compare/ohdear' },
        { label: 'vs Uptime Kuma', href: '/compare/uptime-kuma' },
        { label: 'vs Pulsetic', href: '/compare/pulsetic' },
        { label: 'All comparisons', href: '/compare' },
        { label: 'Alternatives', href: '/alternatives' },
      ],
    },
  ],
}

